import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * EL BOTÓN FLOTANTE DE ATHENA.
 *
 * Mandato: *"Botón flotante de Athena (56 px) en todas las pantallas, encima de
 * la barra, sin tapar contenido. Se esconde al bajar y reaparece al subir."*
 *
 * ═══ POR QUÉ SE ESCONDE AL BAJAR ═══
 *
 * Un botón fijo sobre una lista larga tapa una fila entera. Esconderlo
 * mientras se baja devuelve esa fila, y traerlo de vuelta al subir lo deja
 * disponible justo cuando la persona dejó de leer y está buscando qué hacer.
 *
 * El umbral de 12 px evita que el botón parpadee con los micro-movimientos de
 * un scroll con inercia, que es lo que pasa si se reacciona a cada píxel.
 */

export function BotonAthena() {
  const [visible, setVisible] = useState(true);
  const navegar = useNavigate();
  const ubicacion = useLocation();

  useEffect(() => {
    let anterior = window.scrollY;
    const alRodar = () => {
      const y = window.scrollY;
      if (Math.abs(y - anterior) < 12) return;
      setVisible(y < anterior || y < 40);
      anterior = y;
    };
    window.addEventListener('scroll', alRodar, { passive: true });
    return () => window.removeEventListener('scroll', alRodar);
  }, []);

  // En la propia pantalla de Athena el botón no tiene a dónde llevar.
  if (ubicacion.pathname === '/athena') return null;

  return (
    <button
      onClick={() => navegar('/athena')}
      aria-label="Preguntarle a Athena"
      className={cn(
        'fixed right-4 z-30 grid h-14 w-14 place-items-center rounded-full bg-acento text-white shadow-[0_4px_14px_rgb(0_0_0/0.18)] transition-all duration-200',
        'hover:brightness-105 active:scale-95',
        // Encima de la barra inferior en móvil; abajo del todo en escritorio.
        'bottom-[76px] md:bottom-6',
        visible ? 'translate-y-0 opacity-100' : 'translate-y-24 opacity-0',
      )}
      style={{ marginBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <Sparkles className="h-6 w-6" />
    </button>
  );
}
